var _linearGradient, _linearGradient2, _linearGradient3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitedStates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 15,
    viewBox: "0 0 21 15",
    width: 21,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d02f44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b12537"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#46467f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c3c6d"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h21v15h-21z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h21v1h-21zm0 2h21v1h-21zm0 2h21v1h-21zm0 2h21v1h-21zm0 2h21v1h-21zm0 2h21v1h-21zm0 2h21v1h-21zm0 2h21v1h-21z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h9v7h-9z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.5 2c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5.5.22385763.5.5-.22385763.5-.5.5zm2 0c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5.5.22385763.5.5-.22385763.5-.5.5zm2 0c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5.5.22385763.5.5-.22385763.5-.5.5zm2 0c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5.5.22385763.5.5-.22385763.5-.5.5zm-5 1c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5.5.22385763.5.5-.22385763.5-.5.5zm2 0c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5.5.22385763.5.5-.22385763.5-.5.5zm2 0c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5.5.22385763.5.5-.22385763.5-.5.5zm1 1c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5.5.22385763.5.5-.22385763.5-.5.5zm-2 0c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5.5.22385763.5.5-.22385763.5-.5.5zm-2 0c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5.5.22385763.5.5-.22385763.5-.5.5zm-2 0c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5.5.22385763.5.5-.22385763.5-.5.5zm1 1c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5.5.22385763.5.5-.22385763.5-.5.5zm2 0c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5.5.22385763.5.5-.22385763.5-.5.5zm2 0c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5.5.22385763.5.5-.22385763.5-.5.5zm1 1c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5.5.22385763.5.5-.22385763.5-.5.5zm-2 0c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5.5.22385763.5.5-.22385763.5-.5.5zm-2 0c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5.5.22385763.5.5-.22385763.5-.5.5zm-2 0c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5.5.22385763.5.5-.22385763.5-.5.5z",
    fill: "url(#a)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedStates);
export default __webpack_public_path__ + "static/media/united-states.792f4de9f1612f7437799de54d905fbb.svg";
export { ForwardRef as ReactComponent };